import React from "react";
import {Box, Button, Typography} from "@mui/material";
import {IShelvesCategoryTreeChildDto} from "../../dtos/flyer";
import {makeStyles} from "@mui/styles";
import {isMobile} from "react-device-detect";
import {useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {StoreProjectDto} from "../../dtos/siteDto";

const useStyles = makeStyles(() => ({
    secondaryCategory: (props: any) => ({
        direction: props.direction,
        padding: `0 2px`,
        height: `100%`,
        width: `100%`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        '& > .MuiTypography-root': {
            fontFamily: props.fontFamily,
        },
        '& > .MuiButton-root': {
            padding: `8px`,
            display: `flex`,
            alignItems: `center`,
            justifyContent: `center`,
            width: `100%`,
            backgroundColor: props.isSelected ? '#5892CA' : `#D6D6D6`,
            '& > .MuiTypography-root': {
                color: props.isSelected ? `#ffffff` : `#5892CA`,
                textOverflow: `ellipsis`,
                overflow: `hidden`,
                whiteSpace: `nowrap`,
                width: `100%`,
            },
            '&:hover': {
                outline: `2px solid #5892CA`,
                backgroundColor: `#D6D6D6!important`,
                color: `#5892CA`,
                '& .MuiTypography-root': {
                    color: `#5892CA`,
                },
            }
        },
    })
}))

interface Props {

    category: IShelvesCategoryTreeChildDto;
    onChangeSecondaryCategory: (e: IShelvesCategoryTreeChildDto) => void;
}


export const ShelvesSecondaryCategory: React.FC<Props> = ({
                                                              category,
                                                              onChangeSecondaryCategory,
                                                          }) => {
    const storeGlobalData = useSelector<IAppState, StoreProjectDto | null>((state) => state.storeData);
    const storeData = useSelector((state: IAppState) => state.shelvesScreen.data);
    const flyerBasicData = useSelector((state: IAppState) => state.flyerBranchBasic.data);
    const settingsForStore = storeGlobalData?.isFromFlyer ? flyerBasicData : storeData?.storeSetting;
    const stylesProperties = {
        direction: settingsForStore?.dir?.toLowerCase() || "ltr",
        fontFamily: settingsForStore?.font?.toLowerCase() || "roboto",
        isSelected: category.isSelected,
        primaryColor: settingsForStore?.primaryColorRgb || "#C32E43",
    }
    const classes = useStyles(stylesProperties)

    const onClick = () => {
        onChangeSecondaryCategory(category);
    }

    return (
        <Box className={`${classes.secondaryCategory}`} title={category.caption}>
            <Button onClick={onClick}>
                <Typography textAlign={`center`} color={`#5892CA`} fontSize={isMobile ? `12px` : `14px`}
                            fontWeight={900} height={isMobile ? `12px` : `auto`}
                            fontFamily={settingsForStore?.font?.toLowerCase() || "roboto"}
                >
                    {category.caption ? category.caption.length <= 24 ? category.caption : `${category.caption.substr(0, 23)}...` : ""}
                </Typography>
            </Button>
        </Box>
    )
}